import type { RootState, SuggestionMessage } from '../types';

export function getCallSuggestionsState(state: RootState) {
    return state.callSuggestions;
}

export function getSuggestions(state: RootState): SuggestionMessage[] {
    return getCallSuggestionsState(state).suggestions || [];
}

export function isCallSuggestionsOpen(state: RootState): boolean {
    return Boolean(getCallSuggestionsState(state).callSuggestionsOpen);
}

export function getSuggestionsTimestamp(state: RootState): string {
    return getCallSuggestionsState(state).suggestionsTimestamp || '';
}

export function isCallSuggestionsNew(state: RootState): boolean {
    return Boolean(getCallSuggestionsState(state).isCallSuggestionsNew);
}
